<header class="page-header">
    <div>
        <h1 class="page-header__title">{{ 'authentication.verification.title' | translate }}</h1>
        <p class="page-header__description">{{ 'authentication.verification.subtitle' | translate }}</p>
        <p class="verification__email">
            <span class="material-symbols-outlined icon-sm" aria-hidden="true">mail</span>
            {{ email }}
        </p>
    </div>
</header>

@if (currentError === 'unexpected') {
    <p-message class="verification__message" severity="error">{{
        'authentication.verification.validation.unexpected' | translate
    }}</p-message>
}
<form class="form-grid" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="form-field">
        <span class="form-field__label form-field__label--required">{{
            'authentication.resetPassword.form.verificationCode' | translate
        }}</span>
        <app-input-otp
            [numberOfDigits]="6"
            formControlName="code"
            (atChange)="currentError = undefined"></app-input-otp>
        @if (currentError === 'invalidCode') {
            <small class="p-error">{{ 'authentication.verification.validation.invalidCode' | translate }}</small>
        } @else if (formGroup.controls['code'].touched && formGroup.controls['code'].errors?.required) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        } @else if (formGroup.controls['code'].touched && formGroup.controls['code'].errors?.incomplete) {
            <small class="p-error">{{ 'authentication.verification.validation.invalidCode' | translate }}</small>
        }
    </div>
    <div class="verification__actions">
        <p-button
            severity="secondary"
            [label]="'authentication.verification.form.cancel' | translate"
            [fluid]="true"
            (onClick)="resendCode()" />
        <p-button
            type="submit"
            [loading]="loading"
            [label]="'authentication.verification.form.submit' | translate"
            [fluid]="true" />
    </div>
</form>
